module.exports = __webpack_public_path__ + "media/images/logo/medmij-0c8bcde306bca5fd7998f626253dc25c.png";